/** @format */

import { TExpense } from "../declarations/maps/expenses";
import { TStore } from "../declarations/store";

export const selectorExpenseList = (store: TStore): TExpense[] => store.expenses.expenseList || [];

export const selectorExpense = (store: TStore, id: string): TExpense | undefined =>
  store.expenses.expenseList?.find(expense => expense.id === id) || undefined;
